import { all, fork } from "redux-saga/effects";
import authSaga from "../pages/Auth/saga";
export default function* rootSaga() { yield all([fork(authSaga)]); }
